export default __webpack_public_path__ + "static/media/ilustracao-mulher-mostrando-primeiro-passo.49dfe0a2.svg";